import { Grid } from "@material-ui/core";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DraftsIcon from '@mui/icons-material/Drafts';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ReplayIcon from '@mui/icons-material/Replay';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Button, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { SectionTitle } from "./SettlementDetailsShared";

const SettlementActionSection = ({
  canUserActOnStatus,
  data,
  formData,
  handleChange,
  handleSubmit,
  nextStatusMap,
  setCheckListOpen,
  settlemenNoPartChangePermission,
}) => (        <Grid item xs={12} md={6}>
          <SectionTitle>Action</SectionTitle>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Settlement No"
                type="number"
                name="settlementNo"
                value={formData.settlementNo}
                onChange={handleChange}
                fullWidth
                size="small"
                margin="normal"
                InputProps={{ inputProps: { min: 1 } }}
                required
                disabled = {!settlemenNoPartChangePermission(data.claimStatus)}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControl fullWidth size="small" variant="outlined" margin="normal" required>
                <InputLabel>Settlement Part</InputLabel>
                <Select
                  name="settlementPart"
                  label="Settlement Part"
                  value={formData.settlementPart}
                  onChange={handleChange}
                  disabled = {!settlemenNoPartChangePermission(data.claimStatus)}
                >
                  {[1, 2, 3, 4, 5].map((num) => (
                    <MenuItem key={num} value={num}>
                      {num}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      sx={{ mt: 2 }}
                      onClick={()=>{setCheckListOpen(true)}}
                    >
                      <PendingActionsIcon/>
                      CheckList
                    </Button>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Remarks"
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                fullWidth
                size="small"
              />
            </Grid>

            <Grid item xs={12}>
              {/* --- Show buttons based on claimStatus --- */}
              {(() => {
                const status = data?.claimStatus;
                const SettlementStatus = data?.settlementStatus;
                if( SettlementStatus === 2 ){
                  return (
                    <h1 style={{
                      marginTop: "16px",
                      textAlign: "center", color: "#18ad1fff",
                      border: "1px dashed #18ad1fff",
                      borderRadius: "8px",
                      padding: "10px",
                      fontWeight: 600,
                    }}>
                      <VerifiedIcon/>&nbsp; Claim Settled
                    </h1>
                  );
                }
                
                if (!status) {
                  return (
                    <Button
                      variant="contained"
                      color="inherit"
                      fullWidth
                      sx={{ mt: 2 }}
                      disabled
                    >
                      No Status
                    </Button>
                  );
                }
                  // 🔒 Permission check
                  if (!canUserActOnStatus(status)) {
                    return (
                      <Button
                        variant="contained"
                        color="inherit"
                        fullWidth
                        sx={{ mt: 2 }}
                        disabled
                      >
                        You are not authorized for "{status}" stage
                      </Button>
                    );
                  }


                // if (status === "Settled") {
                //   return (
                //     <p
                //       style={{
                //         marginTop: "16px",
                //         textAlign: "center",
                //         fontWeight: 600,
                //         color: "#2e7d32",
                //       }}
                //     >
                //       Claim Settled
                //     </p>
                //   );
                // }

                const next = nextStatusMap[status]?.next;
                const color = nextStatusMap[status]?.color || "primary";
                const nextIcon = nextStatusMap[status]?.icon ;
                const title = nextStatusMap[status]?.title ;
                const dualButtonStatuses = [
                  "Drafted",
                  "Initiated",
                  "Vetted",
                  "Verified",
                  "Audited"
                ];

                if (dualButtonStatuses.includes(status)) {
                  return (
                    <Grid container spacing={3} sx={{ mt: 1 }}>
                      {
                        status === "Drafted" &&
                            <Grid item xs={4}>
                            <Button
                              variant="contained"
                              fullWidth
                              color="primary"
                              onClick={() => handleSubmit("Drafted")}
                              
                            >
                            <DraftsIcon /> &nbsp;Save Draft 
                            </Button>
                          </Grid>
                      }
                      <Grid item xs={status === "Drafted" ? 4 : 6}>
                        <Button
                          variant="contained"
                          fullWidth
                          color={color}
                          onClick={() => handleSubmit(next)}
                        >
                          {nextIcon}&nbsp; {title}
                        </Button>
                      </Grid>
                      <Grid item xs={status === "Drafted" ? 4 : 6}>
                        <Button
                          variant="contained"
                          fullWidth
                          color="warning"
                          onClick={() => handleSubmit("Sent_Back")}
                        >
                          <ReplayIcon />&nbsp; Send Back
                        </Button>
                      </Grid>
                    </Grid>
                  );
                }

                if (status === "Drafted" || status === "Uploaded") {
                  return (
                    
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ mt: 2 }}
                      color={color}
                      onClick={() => handleSubmit(next)}
                    >
                     {nextIcon}&nbsp; {title}
                    </Button>
                  );
                }
                if (status === "Settled") {
                  return (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ mt: 2 }}
                      color={color}
                      onClick={() => handleSubmit("Bounced")}
                    >
                    <AutorenewIcon />&nbsp;  Bounced
                    </Button>
                  );
                }
                if (status === "Sent_Back" || status === "Bounced") {
                  return (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{ mt: 2 }}
                      color={color}
                      onClick={() => handleSubmit(next)}
                    >
                    {nextIcon} &nbsp; {title}
                    </Button>
                  );
                }

                return (
                  <Button
                    variant="contained"
                    color="success"
                    fullWidth
                    sx={{ mt: 2 }}
                    disabled
                  >
                    Processing for Settlement
                  </Button>
                );
              })()}
            </Grid>
          </Grid>
        </Grid>);

export default SettlementActionSection;
